import React, { useEffect, useRef } from 'react';

import Hls from 'hls.js';

const HLS_LIVE_CONFIG = {
  debug: false,
  enableWorker: true,
  lowLatencyMode: true,
  backBufferLength: 90,
  liveSyncDuration: 1.4,
  liveMaxLatencyDuration: 5,
  maxLiveSyncPlaybackRate: 1.2,
  liveDurationInfinity: true,
  startFragPrefetch: true,
};

const HLS_HISTORY_CONFIG = {
};

export const VideoPlayer = ({ src, autoPlay, height, isArchive }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!src || !videoRef.current) return () => { };

    const hlsConfig = isArchive ? HLS_HISTORY_CONFIG : HLS_LIVE_CONFIG;
    const hls = new Hls(hlsConfig);

    if (Hls.isSupported()) {
      hls.loadSource(src);
      hls.attachMedia(videoRef.current);
      hls.on(Hls.Events.ERROR, console.error);
    } else if ((videoRef.current.canPlayType('application/vnd.apple.mpegurl'))) {
      videoRef.current.src = src;
    }

    return () => {
      if (Hls.isSupported()) {
        hls.destroy();
      }
    };
  }, [src, isArchive]);

  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/media-has-caption
    <video
      autoPlay={autoPlay}
      controls
      ref={videoRef}
      style={{ width: '100%', height: `${height ? '100%' : 'auto'}` }}
    />
  );
};
